import { graphql } from "@leplein/graphql-public/clients/graphql-qrcode-client";

export const GetChargingPoolQuery = graphql(`
  query GetChargingPool($input: ChargingPoolInput!) {
    chargingPool(input: $input) {
      chargingPoolId
      store {
        name
        retailer {
          name
        }
      }
      promotionalOffers {
        type
      }
    }
  }
`);
